module.exports = __webpack_public_path__ + "img/gur_klavim_no.f6b4ae7e.png";